import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { iProduto } from "../../interfaces";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default function Cards({ produtos }: { produtos: iProduto[] }) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  // const maxSteps = images.length;

  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const style3 = {
    width: "100%",
    //height: "45%",
  };

  const style4 = {
    borderRadius: "10px 10px 0 0",
  };

  return (
    <ul className="cardMenu">
      {Array.isArray(produtos) ? (
        produtos.map((produto: iProduto) => (
          <li key={produto.nome} className="card">
            <AutoPlaySwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
              style={style3}
            >
              {produto.img.map((step: any, index: any) => (
                <div key={step.alt} style={style4}>
                  {Math.abs(activeStep - index) <= 2 ? (
                    <Box
                      component="img"
                      sx={{
                        height: 180,
                        display: "block",
                        maxWidth: 300,
                        overflow: "hidden",
                        width: "100%",
                        objectFit: "cover", // Adiciona a propriedade object-fit: cover
                      }}
                      style={style4}
                      src={step.src}
                      alt={step.alt}
                    />
                  ) : null}
                </div>
              ))}
            </AutoPlaySwipeableViews>
            {/* COLOCA OS BOTÕES DE PRÓXIMO E VOLTAR! */}
            <div className="container_card">
              <h2 className="nome_produto">{produto.nome}</h2>
              <span>Preço: {produto.preco}</span>
              <span>
                {produto.cupom ? `Cupom: ${produto.cupom}` : "Cupom: Sem cupom"}
              </span>
              <span>Fonte: {produto.fonte}</span>
              <span>OBS: {produto.obs}</span>
              <div className="container">
                <a href={produto.link_compra} className="link" target="_blank">
                  COMPRAR
                </a>
                {/* <a href={produto.link_video} className="link" target="_blank">
                VÍDEO
              </a> */}
              </div>
            </div>
          </li>
        ))
      ) : (
        <p>Nenhum produto disponível.</p>
      )}
    </ul>
  );
}

/* <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            PRÓXIMA
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={handleBack}
            disabled={activeStep === 0}
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            VOLTAR
          </Button>
        }
/> */
